import React from "react";
import ModalInfo from "../../ModalInfo";

import { Accordion, Card } from "react-bootstrap";

class Page3 extends React.Component {
  state = {
    visible: true,

    modalShow: true,
    instructions: (
      <div>
        <p>
          Whether you are considering applying for graduate schemes, a PhD or
          prefer to apply for graduate jobs after you complete your studies – we
          want to make sure you have a plan of action to enable you to be
          successful.
        </p>
      </div>
    ),
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 3) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    let modalClose = () => this.setState({ modalShow: false });

    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0  d-md-block">Plan of Action</h3>
                </li>
                <li className="nav-item"></li>
              </ul>
              <ul className="nav navbar-nav ml-auto">
                <div>
                  <i
                    className="fas fa-info-square fa-3x"
                    onClick={() => this.setState({ modalShow: true })}
                  ></i>
                </div>
              </ul>
            </nav>

            <div className="container vertical-center">
              <div id="moduleContentText_2">
                <div
                  className="card mb-4 box-shadow h-100"
                  id="pageContent_2"
                  style={{ cursor: "pointer" }}
                >
                  <Accordion defaultActiveKey="0">
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="0">
                        <center>
                          <strong>August - October</strong>
                        </center>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="0">
                        <Card.Body>
                          <span id="moduleContentText_2">
                            <p>
                              <ol>
                                <li>
                                  Maintain your network by connecting with{" "}
                                  <a
                                    target="_blank"
                                    href="https://www.bath.ac.uk/campaigns/bath-connection/"
                                  >
                                    the alumni community
                                  </a>{" "}
                                  and the Careers Service in your previous
                                  University.
                                </li>
                                <br />
                                <li>
                                  Use our fantastic online resources to{" "}
                                  <a
                                    target="_blank"
                                    href="https://xerte.bath.ac.uk/play.php?template_id=410"
                                  >
                                    update your CV
                                  </a>{" "}
                                  and{" "}
                                  <a
                                    target="_blank"
                                    href="https://www.linkedin.com/"
                                  >
                                    LinkedIn profile
                                  </a>
                                  .
                                </li>
                                <br />
                                <li>
                                  Research{" "}
                                  <a
                                    target="_blank"
                                    href="https://targetjobs.co.uk/"
                                  >
                                    graduate schemes
                                  </a>{" "}
                                  or{" "}
                                  <a
                                    target="_blank"
                                    href="https://www.findaphd.com/advice/finding/what-is-a-phd.aspx"
                                  >
                                    PhD programmes
                                  </a>{" "}
                                  that interest you.
                                </li>
                              </ol>
                            </p>
                          </span>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="1">
                        <center>
                          <strong>October – December</strong>
                        </center>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="1">
                        <Card.Body>
                          <span id="moduleContentText_2">
                            <p>
                              <ol>
                                <li>
                                  Book a{" "}
                                  <a
                                    target="_blank"
                                    href="https://www.bath.ac.uk/guides/careers-service-appointments/"
                                  >
                                    1:1 meeting with a Careers Adviser
                                  </a>{" "}
                                  , use the appointment to gain CV feedback,
                                  discuss your career options and learn about
                                  the support available to you.
                                </li>
                                <br />
                                <li>
                                  Attend careers events on campus, over 500
                                  employers come to Bath every year. You will be
                                  able to access the{" "}
                                  <a
                                    target="_blank"
                                    href="https://unihub.bath.ac.uk/students/login?ReturnUrl=%2fs%2fmyfuture"
                                  >
                                    full events list on MyFuture
                                  </a>
                                  .
                                </li>
                                <br />
                                <li>
                                  Research your{" "}
                                  <a
                                    target="_blank"
                                    href="http://www.bath.ac.uk/students/careers/information-resources/catalogue/occupational/index.html"
                                  >
                                    career options
                                  </a>
                                  .
                                </li>
                              </ol>
                            </p>
                          </span>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="2">
                        <center>
                          <strong>January – April</strong>
                        </center>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="2">
                        <Card.Body>
                          <span id="moduleContentText_2">
                            <p>
                              <ol>
                                <li>
                                  Start preparing for{" "}
                                  <a
                                    target="_blank"
                                    href="https://xerte.bath.ac.uk/play.php?template_id=411"
                                  >
                                    Interviews and Assessment
                                  </a>{" "}
                                  centres. Attend a careers talk or employer led
                                  workshop.
                                </li>
                                <br />
                                <li>
                                  Network to tap into those hidden
                                  opportunities.
                                </li>
                                <br />
                                <li>
                                  Apply for graduate vacancies{" "}
                                  <a
                                    target="_blank"
                                    href="https://www.bath.ac.uk/services/myfuture/#working-for-smaller-companies"
                                  >
                                    especially with SME’s
                                  </a>
                                  .
                                </li>
                              </ol>
                            </p>
                          </span>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="3">
                        <center>
                          <strong>May</strong>
                        </center>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="3">
                        <Card.Body>
                          <span id="moduleContentText_2">
                            <p>You’ll be focused on your exams.</p>
                          </span>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="4">
                        <center>
                          <strong>June – September</strong>
                        </center>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="4">
                        <Card.Body>
                          <span id="moduleContentText_2">
                            <p>
                              <ol>
                                <li>
                                  Book a{" "}
                                  <a
                                    target="_blank"
                                    href="https://www.bath.ac.uk/guides/careers-service-appointments/"
                                  >
                                    1:1 meeting with a Careers Adviser
                                  </a>{" "}
                                  , use the appointment to review your job
                                  hunting strategy.
                                </li>
                                <br />
                                <li>
                                  Consider a{" "}
                                  <a
                                    target="_blank"
                                    href="https://www.gov.uk/find-internship"
                                  >
                                    graduate internship
                                  </a>
                                </li>
                                <br />
                                <li>
                                  Expand your job hunting sources for example by
                                  working with specialist recruiters, your
                                  careers adviser will be able to help.{" "}
                                  <a
                                    target="_blank"
                                    href="https://www.bath.ac.uk/services/myfuture/"
                                  >
                                    This page explains when they can be useful
                                  </a>
                                  .
                                </li>
                              </ol>
                            </p>
                          </span>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
              </div>
            </div>
            <ModalInfo
              show={this.state.modalShow}
              onHide={modalClose}
              title="INSTRUCTIONS"
              content={this.state.instructions}
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page3;
